module.exports = __webpack_public_path__ + "media/images/front/icons/email-a1ddca600a22995feac28876c1ce2f43.png";